// extracted by mini-css-extract-plugin
module.exports = {"priceContainer":"product-card-price_priceContainer__Cz9Wd"};